import gsap from 'gsap';
import { init as globalInit } from './modules/global';
import { init as navigationInit } from './modules/navigation';
import { init as homeHeroInit } from './modules/home-hero';
import { init as buttonsInit } from './modules/buttons';
import { init as mouseFollowInit } from './modules/mouse-follow';
import { init as animationsInit } from './modules/animations';
import { init as stepsBlockInit } from './modules/steps-block';
import { init as solutionsInit } from './modules/solutions';
import { init as dataSystemsInit } from './modules/data-systems';
import { init as testimonialsInit } from './modules/testimonials';
import { init as statsInit } from './modules/stats';
import { init as resourcesSliderInit } from './modules/resources-slider';
import { init as carouselInit } from './modules/carousel';
import { init as ourDataHeroInit } from './modules/our-data-hero';
import { init as pricingInit } from './modules/pricing';
import { init as videoInit } from './modules/video';
import { hubspotInit } from './modules/hubspot';

let isRM = false;

gsap.matchMedia().add(
  {
    rM: '(prefers-reduced-motion: reduce)'
  },
  (ctx) => {
    isRM = ctx.conditions.rM;
  }
);

gsap.defaults({ duration: !isRM ? 0.5 : 0.0001 });
hubspotInit();
navigationInit();
resourcesSliderInit();
mouseFollowInit(isRM);
homeHeroInit(isRM);
buttonsInit(isRM);
stepsBlockInit(isRM);
dataSystemsInit(isRM);
testimonialsInit(isRM);
animationsInit(isRM);
statsInit(isRM);
carouselInit();
ourDataHeroInit(isRM);
pricingInit(isRM);
videoInit();
globalInit(isRM);
solutionsInit(isRM);
